<!-- START THE TOUR PAGE -->
<div class="container-fluid px-0 signin" (window:resize)="onResize($event)" [style.minHeight.px]="myInnerHeight">
    <ng-container *ngIf="policyPath != null">
  
  <div class="login-box row mx-0 font-roboto-cad" style="padding: 3% 0">
    <div class="col-12">
        <div style="display: flex; justify-content: center;" >
            <iframe [src]="policyPath" width="800" height="800"></iframe> 
        </div>
        <div class="mt-3" style="display: flex; justify-content: center; align-items: center; position: relative; left: 42%;">
            <input type="checkbox" class="font-16"  id="acceptPolicy" [(ngModel)]="acceptedPrivacyPolicy">
        <label class=" ml-2 font-15 w-100 txt-btn mt-2" for="acceptPolicy">I accept the Privacy Policy</label>
        </div>
        
    </div>
    <div class="col-2 mt-3" style="position: relative; left: 35%;">
            <button class="btn btn-account" type="button" (click)="goBack()">{{'Back' | translate}}</button>
    </div>
    <div class="col-2 mt-3 " style="position: relative; left: 35%;" >
        <button class="btn btn-account" type="button"  (click)="goToWelcomeScreenP()">{{'Start the tour' | translate}}</button>
</div>
</div>
    </ng-container>
    <ng-container *ngIf="!(policyPath != null)">
        <div class="login-box row mx-0 font-roboto-cad" style="padding: 10% 0">
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mx-auto">
                <h3 class="title3 txt-btn text-center font-20">Let's Start</h3>
                <div class="row mx-auto w-100 my-4">
                    <img src="assets/img/signin-icon-white.png" alt="" class="logo1 mx-auto">
                </div>
                <div class="row mx-auto my-4">
                    <img src="assets/img/Teamium-white.png" alt="" class="img-fluid logo2 mx-auto">
                    <p class="font-15 w-100 txt-btn text-center  mt-2">PRODUCTION PLATFORM</p>
                </div>
                <div class="row mx-auto w-100 my-4" style="position: relative; z-index: 100;">
                    <button class="btn btn-account" type="button" (click)="goToWelcomeScreen()">{{'Start the tour' | translate}}</button>
                </div>
            </div>
        </div>
        <div class="area" >
            <ul class="circles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>

    </ng-container>
</div>